module.exports = __webpack_public_path__ + "static/chartering-static-71ecd76125135ab1a61599d5aa068bec.jpg";